"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@gibme/web-ui");
const finance_1 = __importDefault(require("@gibme/finance"));
$(() => {
    $('#si-principal, #si-interest, #si-years').on('change, keyup', () => {
        const principal = parseFloat($('#si-principal').val()) || 0;
        const interest = parseFloat($('#si-interest').val()) || 0;
        const years = parseFloat($('#si-years').val()) || 0;
        const { payment, total_interest, total_amount } = finance_1.default.calculate_simple_interest_loan(principal, interest, years * 12);
        $('#si-total-amount').val($.numeral(total_amount).format('0,0.00'));
        $('#si-total-interest').val($.numeral(total_interest).format('0,0.00'));
        $('#si-monthly-payment').val($.numeral(payment).format('0,0.00'));
    });
    $('#ac-principal, #ac-interest, #ac-years').on('change, keyup', () => {
        const principal = parseFloat($('#ac-principal').val()) || 0;
        const interest = parseFloat($('#ac-interest').val()) || 0;
        const years = parseFloat($('#ac-years').val()) || 0;
        const { payment, total_interest, total_amount } = finance_1.default.calculate_amortization_loan(principal, interest, years * 12);
        $('#ac-total-amount').val($.numeral(total_amount).format('0,0.00'));
        $('#ac-total-interest').val($.numeral(total_interest).format('0,0.00'));
        $('#ac-monthly-payment').val($.numeral(payment).format('0,0.00'));
    });
    $('#ma-cost, #ma-price').on('change, keyup', () => {
        const cost = parseFloat($('#ma-cost').val()) || 0;
        const price = parseFloat($('#ma-price').val()) || 0;
        const markup = finance_1.default.calculate_markup(cost, price);
        $('#ma-markup').val($.numeral(markup * 100).format('0.00'));
    });
    $('#mc-cost, #mc-price').on('change, keyup', () => {
        const cost = parseFloat($('#mc-cost').val()) || 0;
        const price = parseFloat($('#mc-price').val()) || 0;
        const margin = finance_1.default.calculate_margin(cost, price);
        $('#mc-margin').val($.numeral(margin * 100).format('0.00'));
    });
});
